import { render, staticRenderFns } from "./LeaveStatusCheckDialog.vue?vue&type=template&id=23195786&scoped=true"
import script from "./LeaveStatusCheckDialog.vue?vue&type=script&lang=js"
export * from "./LeaveStatusCheckDialog.vue?vue&type=script&lang=js"
import style0 from "./LeaveStatusCheckDialog.vue?vue&type=style&index=0&id=23195786&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23195786",
  null
  
)

export default component.exports